module.exports = __webpack_public_path__ + "img/Flag_of_the_Czech_Republic.675b5be5.svg";